import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {ServicesService} from "../../services/services-service.service";
import {ExpensesDialogService} from "../../../expenses/services/expenses-dialog.service";
import {ExpensesService} from "../../../expenses/services/expenses-service.service";
import {FulfillmentDialogService} from "../../../fulfillment/services/fulfillment-dialogs-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {PrinterService} from "../../../commons/services/printer-service.service";
import {FulfillmentService} from "../../../fulfillment/services/fulfillment-service.service";

export class ServiceActionMenuCtrl implements IController {
  service: any;
  onAction: Function;
  onToggleMap: Function;

  private actions: any;
  private extraActions: any;
  public extraActionNames: any;


  /* @ngInject */
  constructor(private deliveriesConstants, private DeliveriesApiAction,
              private printerService: PrinterService, private splitService: SplitService,
              private $timeout: ITimeoutService, private servicesService: ServicesService, private commonsDialogService: CommonsDialogService,
              private deliveriesDialogService: DeliveriesDialogService, private expensesDialogService: ExpensesDialogService,
              private expensesService: ExpensesService, private fulfillmentService: FulfillmentService) {
  }

  $onInit() {
    this.extraActionNames = this.deliveriesConstants.servicesExtraActions;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    // if (changes.service && !changes.service.isFirstChange()) {
    //   this.initActions();
    // }
  }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onOpen($mdMenu, ev) {

    this.initActions();

    if (_.isEmpty(this.actions) && _.isEmpty(this.extraActions)) {
      return;
    }

    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  private initActions() {
    this.actions = [];
    this.extraActions = [];

    const actions = this.servicesService.getActionsByServices([this.service]);

    this.actions = _.filter(actions, (a) => {
      return !Object.values(this.extraActionNames).some((item: any) => item?.id === a.id)
    });
    this.extraActions = _.filter(actions, (a) => {
      return Object.values(this.extraActionNames).some((item: any) => item?.id === a.id)
    });

  }

  closeActionsMenu($mdMenu, ev) {
    this.actions = [];
    this.extraActions = [];
    $mdMenu.close();
  }

  onActionSelect(action, $event) {
    // onExtraActionSelect(action);
    this.DeliveriesApiAction[action]($event, [this.service.id], this.service.serviceType)
      .then((serviceIds) => {
        if (_.isArray(serviceIds) && serviceIds[0]) {
          this.onAction({serviceId: serviceIds[0]});
        }
      })
  }

  onExtraActionSelect(actionId, $event) {

    if (actionId === 'editPackages') {
      this.onActionSelect(actionId, $event);
    }

    if (actionId === 'edit') {
      this.servicesService.onEditOne(this.service, false);
    } else if (actionId === 'Duplicate') {
      this.servicesService.onDuplicateOne(this.service);
    } else if (actionId === 'Print') {
      if (this.service.serviceType === 'Operation') {
        this.servicesService.onPrint([this.service.id]);
      } else {
        this.deliveriesDialogService.printDelivery()
          .then((purpose) => {
            this.servicesService.onPrint([this.service.id], purpose);
          })
      }
    } else if (actionId === 'PrintLabel') {
      this.printerService.printDelivery(this.service);
    } else if (actionId === 'DownloadLabel') {
      this.printerService.downloadDeliveryToPdf(this.service);
    } else if (actionId === 'PrintIkea') {
      this.commonsDialogService.printIkea([this.service]);
    } else if (actionId === 'CreateExpense') {
      this.expensesDialogService.createExpense($event, this.service.id)
        .then((expense) => {
          this.expensesService.createExpense(expense);
        })
    } else if (actionId === 'dispatchExternal') {
      this.deliveriesDialogService.dispatchStepExternal(this.service.fulfillmentId, this.service.fulfillmentStepId, $event)
        .then((selectedQuote) => {
          this.fulfillmentService.dispatchStep(this.service.fulfillmentId, this.service.fulfillmentStepId, selectedQuote);
        })
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceActionMenu', {
    bindings: {
      service: '<',
      onAction: '&',
      onToggleMap: '&'
    },
    template: require('./service-action-menu.html').default,
    controller: ServiceActionMenuCtrl
  });

